<template>
  <radio-group-input
    class="energy-efficiency-select"
    :label="label"
    :value="value"
    :collection="energyEfficiencyClasses"
    :errors="errors"
    @input="onInput"
    include-blank="Keine"
  >
    <template slot="option" scope="optionProps">
      <energy-efficiency-class :value="optionProps.value" />
    </template>
  </radio-group-input>
</template>

<script>
import Input from '@/mixins/Input';
import EnergyEfficiencyClass from '@/components/EnergyEfficiencyClass';
import RadioGroupInput from '@/components/RadioGroupInput';

const CLASSES = [
  'A_TRIPLE_PLUS',
  'A_DOUBLE_PLUS',
  'A_PLUS',
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
  'G',
];

export default {
  name: 'energy-efficiency-select',
  mixins: [Input],
  components: {
    EnergyEfficiencyClass,
    RadioGroupInput,
  },
  props: {
    value: String,
  },
  data() {
    return {
      energyEfficiencyClasses: CLASSES,
    };
  },
  methods: {
    onInput(value) {
      if (value) {
        this.$emit('input', value);
        this.$emit('change', value);
      } else {
        this.$emit('input', null);
        this.$emit('change', null);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// EnergyEfficiencySelect.vue?820215ee